import { lazy } from 'react'
import { Navigate, Outlet, Route, Routes } from 'react-router-dom'

import OrdemListarLayout from '../layouts/order-controller-header'
import OrdemDetalharLayout from '../layouts/order-details-header'

const OrderList = lazy(() => import('../pages/orderList'))
const OrderDetails = lazy(() => import('../pages/orderDetails'))
const OrderReports = lazy(() => import('../pages/orderReports'))
const OrderItems = lazy(() => import('../pages/orderItems-v2'))

export default function Component() {
  return (
    <Routes>
      <Route path="servico" element={<Outlet />}>
        <Route path="" element={<OrdemListarLayout isSale={false} />}>
          <Route index element={<OrderList type="SERVICO" />} />
        </Route>
        <Route path=":orderId" element={<OrdemDetalharLayout isSale={false} />}>
          <Route path="detalhes" element={<OrderDetails />} />
          <Route path="tecnico" element={<OrderReports />} />
          <Route path="itens" element={<OrderItems />} />
        </Route>
      </Route>
      <Route path="venda" element={<Outlet />}>
        <Route path="" element={<OrdemListarLayout isSale={true} />}>
          <Route index element={<OrderList type="VENDA" />} />
        </Route>
        <Route path=":orderId" element={<OrdemDetalharLayout isSale={true} />}>
          <Route path="detalhes" element={<OrderDetails />} />
          <Route path="itens" element={<OrderItems />} />
        </Route>
      </Route>
      <Route index element={<Navigate to="servico" />} />
    </Routes>
  )
}
